(function($) {
	Cyberhouse.DeviceUtil = {
		viewPortWidth: function () {
			var e = window, a = 'inner';
			if (!( 'innerWidth' in window )) {
				a = 'client';
				e = document.documentElement || document.body;
			}
			return e[a + 'Width'];
		},
		isMobileDevice992: function () {
			return this.viewPortWidth() < 992;
		},
		isMobileDevice768: function () {
			return this.viewPortWidth() < 768;
		},
		isMobileDevice620: function () {
			return this.viewPortWidth() < 620;
		},
		isMobileDevice1199: function () {
			return this.viewPortWidth() < 1199;
		},
		isMobileDevice480: function () {
			return this.viewPortWidth() < 480;
		}
	};

/**
 * window width
 */
var w = 0;

/**
 * set timeout for window resize
 */
var waitForFinalEvent = (function () {
	var timers = {};
	return function (callback, ms, uniqueId) {
		if (timers[uniqueId]) {
			clearTimeout(timers[uniqueId]);
		}
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();

var DropDownMenuUtil = {
	enableHeaderDropDownMenu: function () {
		$('header .navbar .dropdown-menu').parent().children('.dropdown-toggle').attr('data-toggle', 'dropdown');
	},
	disableHeaderDropDownMenu: function () {
		$('header .navbar .dropdown-menu').parent().children('.dropdown-toggle').removeAttr('data-toggle');
	}
};
var ResponsiveSliderUtil = ResponsiveSliderUtil || {
	updateCaptionsAllSliders: function () {
	}
};

var GeneralResizeMethods = {
	showHideTopLink: function (fadeTime) {
		var body = $("body");
		if ((body.prop('scrollHeight') - body.find('footer').height()) > body.height()) {
			$(".bottom-links").fadeIn(fadeTime);
		} else {
			$(".bottom-links").fadeOut(fadeTime);
		}
	},

	teaserImagesModifyRows: function (countImagesPerRow) {
		var teaserImages = $('.teaser-images');
		var teaserRows = teaserImages.find('.teaser-row');
		if (teaserRows.first().children('.teaser-col') != countImagesPerRow) {
			var columnCount = 0;
			var teaserRow = null;
			var teaserRowContainer = null;
			var teaserColumns = teaserRows.find('.teaser-col');
			teaserColumns.each(function (index, teaserColumn) {
				teaserColumn = $(teaserColumn);
				if ((teaserRow == null) || ((columnCount % countImagesPerRow) == 0)) {
					if (teaserRowContainer != null) {
						teaserRowContainer.appendTo(teaserImages);
					}
					teaserRow = $('<div class="teaser-row"></div>');
					var teaserTable = $('<div class="teaser-table"></div>');
					teaserRowContainer = $('<div class="teaser-row-container"></div>');
					teaserRow.appendTo(teaserTable);
					teaserTable.appendTo(teaserRowContainer);
				}
				teaserColumn.appendTo(teaserRow);
				columnCount++;
			});
			if (teaserRowContainer != null) {
				teaserRowContainer.appendTo(teaserImages);
			}
			teaserRows.remove();
		}
	}
};

/**
 * change design/scripts after resize (between mobile and desktop devices)
 */
var resizeEventDuration = 100;
Cyberhouse.ResizeUtil = {

	doDesktopDeviceChanges: function () {
		DropDownMenuUtil.enableHeaderDropDownMenu();
	},

	doMobileDevice1199Changes: function () {
		DropDownMenuUtil.disableHeaderDropDownMenu();
	},

	doGeneralChangesOnResize: function () {
		GeneralResizeMethods.showHideTopLink(300);
	},

	doGeneralChangesOnInit: function () {
		GeneralResizeMethods.showHideTopLink(0);
	},

	checkAndDoChangesOnInit: function () {
		this.doGeneralChangesOnInit();
		if (DeviceUtil.isMobileDevice620()) {
			GeneralResizeMethods.teaserImagesModifyRows(2);
		} else {
			GeneralResizeMethods.teaserImagesModifyRows(3);
		}
		if (DeviceUtil.isMobileDevice1199()) {
			this.doMobileDevice1199Changes();
		} else {
			this.doDesktopDeviceChanges();
		}
	},

	checkAndToggleFilter: function () {
		if (w != $(window).width()) {
			if (!Cyberhouse.DeviceUtil.isMobileDevice768()) {
				$('#filterCollapse').collapse('show');
			} else {
				$('#filterCollapse').collapse('hide');
			}
			w = $(window).width();

			delete w;
		}
	},

	checkAndDoChangesOnResize: function () {
		this.doGeneralChangesOnResize();
		if (DeviceUtil.isMobileDevice620()) {
			GeneralResizeMethods.teaserImagesModifyRows(2);
		} else {
			GeneralResizeMethods.teaserImagesModifyRows(3);
		}
		if (DeviceUtil.isMobileDevice1199()) {
			this.doMobileDevice1199Changes();
		} else {
			this.doDesktopDeviceChanges();
		}
		ResponsiveSliderUtil.updateCaptionsAllSliders();
	},

	init: function () {
		ResizeUtil.checkAndDoChangesOnInit();

        $(window).resize(function () {
            waitForFinalEvent(function () {
                ResizeUtil.checkAndDoChangesOnResize();
            }, resizeEventDuration);
        });
    },

	initFilters: function () {
        Cyberhouse.ResizeUtil.checkAndToggleFilter();
        w = $(window).width();
        $(window).resize(function () {
            waitForFinalEvent(function () {
                Cyberhouse.ResizeUtil.checkAndToggleFilter();
            }, resizeEventDuration);
        });
	}
};

$(function () {
    if ($('#filterCollapse').length > 0) {
        Cyberhouse.ResizeUtil.initFilters();
    }
});

})(jQuery);
